module.exports = __webpack_public_path__ + "img/ch18_02_星轨会议.0e64c96d.jpg";